module.exports = __webpack_public_path__ + "img/acdb30e906a2af84d2c91c41558f7b98.png";